import { Skeleton } from '../ui/skeleton'
import { useIsMobile } from '@/hooks/use-mobile'
import { cn } from '@/lib/utils'
import { Outlet } from '@tanstack/react-router'

export function LoadingSidebarLayout() {
  const isMobile = useIsMobile()
  return (
    <main className={cn('main-container', isMobile && 'mt-15 mb-20')}>
      <LoadingSidebar />
      <Outlet />
    </main>
  )
}

function LoadingSidebar() {
  return (
    <div className="bg-background flex h-full w-64 min-w-64 flex-col border-r">
      {/* <div className="flex h-14 items-center border-b px-4">
        <div className="flex w-full items-center gap-2">
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div> */}
      <div className="flex-1 overflow-auto p-4">
        <div className="space-y-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <div className="space-y-1">
              <Skeleton className="h-8 w-full" />
              <Skeleton className="h-8 w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
